import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
       default:
          "bg-[#D4AF37] text-black hover:bg-[#F5CF57] shadow-md",
        
        outline:
          "border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF3720] hover:text-white",
        
        destructive:
          "bg-red-600 text-white hover:bg-red-700 shadow-md",
        
        secondary:
          "bg-[#1A1A1A] text-gray-200 border border-[#333] hover:bg-[#2A2A2A]",
        
        ghost:
          "text-gray-300 hover:bg-[#33333380] hover:text-white",
        
        link:
          "text-[#D4AF37] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-x",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
